import { createAction } from '@reduxjs/toolkit';

interface InvalidateSessionPayload {
    isVoluntaryLogout?: boolean;
    isAuthEndpointFailure?: boolean;
}

export const invalidateSession = createAction<
    InvalidateSessionPayload | undefined
>('session/invalidateSession');
